module.exports = __webpack_public_path__ + "static/img/icon_fire.1368a239.png";